import Glide from '@glidejs/glide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//slider de talleres
/*ar workshopSlider = new Glide('.section3a__slider', {
    type: 'carousel',
    startAt: 0,
    perView: 2.75,
    swipeThreshold: false,
    dragThreshold: false,
    breakpoints: {
        991: {
            perView: 1.75,
        },
        768: {
            perView: 1,
        },
    },

}).on('move', () => {
    let currentIndex = talleres;
    //workshopSlider.index empieza en cero y en la condición debe ser: (num_talleres/2) - 1 -> currentIndex = num_talleres
    if (workshopSlider.index === (Math.ceil(currentIndex / 2) - 1)) {
        if (screen.width <= 991) {
            if (document.querySelector('.section3a__item') != null) {
                if (talleres % 2 === 0) {
                    currentIndex = talleres;
                } else {
                    currentIndex = talleres - 1;
                }
            } else {
                currentIndex = 0;
            }
        } else {
            if (document.querySelector('.section3a__item') != null) {
                currentIndex = 2;
            } else {
                currentIndex = 0;
            }
        }
    } else {
        if (document.querySelector('.section3a__item') != null) {
            currentIndex = workshopSlider.index * 2 + getVisibleSlides();
        } else {
            currentIndex = 0;
        }
    }
    document.querySelector('.workshop__current-slide').textContent = currentIndex;
});
workshopSlider.mount();*/

//numero de sliders visibles en el slider de los talleres
function getVisibleSlides() {
    const containerWidth = document.querySelector('.glide__track').offsetWidth;
    if (document.querySelector('.section3a__item') != null){
        const slideWidth = document.querySelector('.section3a__item').offsetWidth;
        // Número de slides visibles (se redondea hacia abajo para obtener el entero)
        const visibleSlides = Math.floor(containerWidth / slideWidth);
        return visibleSlides*2;
    }
}


//scroll de tarjetas y queda fija la sección del sorteo
const imageContainer = document.querySelector('.floating-image');
const card1 = document.querySelector('.section3b__card1');
const card2 = document.querySelector('.section3b__card2');
const card3 = document.querySelector('.section3b__card3');

// Función para actualizar la imagen dinámicamente
function updateImage(imageSrc) {
    if (!imageSrc) {
        gsap.to(imageContainer, { opacity: 0, duration: 0.2 }); // En lugar de ocultarla, la hacemos tenue
    } else {
        gsap.to(imageContainer, { opacity: 0.3, duration: 0.2, y: '-25px', onComplete: () => {
                imageContainer.style.backgroundImage = `url(${imageSrc})`;
                gsap.to(imageContainer, { opacity: 1, duration: 0.2, y: 0 }); // Recupera la opacidad suave
            }});
    }
}

let mm = gsap.matchMedia();
mm.add(
    "(min-width:992px) and (min-height:850px)",() => {
        gsap.to(".section3b__cards-wrapper", {
            scrollTrigger: {
                trigger: ".section3b__cards-wrapper",
                start: "top 100px",
                end: "+=2900",
                pin: true,               // Mantiene el contenedor "fijo"
                pinSpacing: false,        // Evita que el espacio extra se añada después del "pin"
            }
        });
        gsap.to(".vertical-bar", {
            scrollTrigger: {
                trigger: ".section3b__cards-wrapper",
                start: "top 100px",
                end: "+=2900",
                scrub: true, // Hace que la animación sea progresiva con el scroll
            },
            height: "100%", // Se llenará completamente
            ease: "none"
        });
//hacer que los cards dentro de la sección hagan toggle de la clase active
        gsap.to(card1, {
            scrollTrigger: {
                trigger: card1,
                start: "top-=100 top",
                end: "+=950",
                scrub: true,
                toggleClass: {targets: card1, className: "active"},
                onEnter: () => updateImage(card1.getAttribute("data-image")), // Obtiene la URL dinámica
                onEnterBack: () => updateImage(card1.getAttribute("data-image")), // Obtiene la URL dinámica
                onLeaveBack: () => updateImage("")
            }
        });
        gsap.to(card2, {
            scrollTrigger: {
                trigger: card2,
                start: "top+=600 top",
                end: "+=950",
                scrub: true,
                toggleClass: {targets: card2, className: "active"},
                onEnter: () => updateImage(card2.getAttribute("data-image")), // Obtiene la URL dinámica
                onEnterBack: () => updateImage(card2.getAttribute("data-image")), // Obtiene la URL dinámica
                onLeaveBack: () => updateImage("")
            }
        });
        gsap.to(card3, {
            scrollTrigger: {
                trigger: card3,
                start: "top+=1350 top",
                end: "+=950",
                scrub: true,
                toggleClass: {targets: card3, className: "active"},
                onEnter: () => updateImage(card3.getAttribute("data-image")), // Obtiene la URL dinámica
                onEnterBack: () => updateImage(card3.getAttribute("data-image")), // Obtiene la URL dinámica
                onLeaveBack: () => updateImage("")
            }
        });
    });


/*//cambiar icono de los botones y longitud de líneas de programación del evento
document.addEventListener("DOMContentLoaded", function () {
    const colapsables = document.querySelectorAll(".accordion-collapse");
    const allLines = document.querySelectorAll('.has-more-menu');
    colapsables.forEach(collapseEl => {
        const collapseId = collapseEl.id;
        const card = collapseEl.closest('.section5__card'); // Encuentra el contenedor de la tarjeta

        // Busca el botón e icono asociado
        const button = document.querySelector(`[data-bs-target="#${collapseId}"]`);
        const icon = button?.querySelector("i");

        if (!button || !icon || !card) return;

        // Encuentra el elemento .has-more-menu dentro de la tarjeta
        const line = card.querySelector('.has-more-menu');

        if(line){
            // Evento cuando se expande una tarjeta
            collapseEl.addEventListener("shown.bs.collapse", function () {

                // Restablecer la altura de todas las líneas a su valor base antes de modificar solo la activa
                resetAlturasLineas();

                icon.classList.remove("fa-plus");
                icon.classList.add("fa-minus");

                // Obtener la altura del contenido visible de la tarjeta expandida
                const alturaTexto = collapseEl.scrollHeight; // La altura del contenido cuando está expandida
                const nuevaAltura = `calc(100% + 6rem - (${alturaTexto / 2}px))`; // Ajusta la línea según la altura del contenido
                // Establece la nueva altura solo para el .has-more-menu de esta tarjeta
                line.style.setProperty("--altura-linea-tree", nuevaAltura);

                allLines.forEach(otherLine => {
                    if (otherLine !== line) {
                        otherLine.style.height = "calc(100% + 3rem + 95px)";
                    }
                });
            });

            // Evento cuando se colapsa una tarjeta
            collapseEl.addEventListener("hidden.bs.collapse", function () {
                icon.classList.remove("fa-minus");
                icon.classList.add("fa-plus");

                // Restablece la altura de la línea a su valor base cuando se colapsa
                const alturaBase = `calc(100% + 3rem)`;
                line.style.setProperty("--altura-linea-tree", alturaBase);
            });
        }
    });

    // Función para restablecer la altura de todas las líneas a su valor base
    function resetAlturasLineas() {
        // Esto asegura que solo las líneas de tarjetas colapsadas sean restablecidas.
        const allLines = document.querySelectorAll('.has-more-menu');
        allLines.forEach(line => {
            // Solo restablecer las líneas de tarjetas que están colapsadas
            const accordionCollapse = line.closest('.section5__card').querySelector('.accordion-collapse');
            if (!accordionCollapse.classList.contains('show')) {
                // Restablece las líneas a su valor base cuando la tarjeta está colapsada
                line.style.setProperty("--altura-linea-tree", "calc(100% + 3rem)");
            }
        });
    }
});*/

//slider de las ofertas de empleo
if ($('.section3c__slider').length){
    var jobOfferSlider = new Glide('.section3c__slider', {
        type: 'slider',
        /*startAt: 0,*/
        perView: 3,
        gap: 0,
        swipeThreshold: false,
        dragThreshold: false,
        breakpoints: {
            991: {
                perView: 2,
            },
            768: {
                perView: 1,
            },
        },

    }).mount();
}
